export default class Top {
  private element: HTMLDivElement
  constructor(el: HTMLDivElement){
    this.element = el
    this.stage(1)
  }
  stage(n: number){
    this.element.className= `stage-${n}`
  }
  message(content: HTMLElement, n?: number){
    var inner = this.element.getElementsByClassName('inner')[0]
    var outer = this.element.getElementsByClassName('outer')[0]
    if(inner && outer){
      while(inner.children.length > 0) {
        outer.appendChild(inner.children[0])
      }
      inner.appendChild(content)
    }
    if(n)
    this.stage(n)
  }
  getContent(){
    this.element.getElementsByClassName('content')[0]
  }
}